import React from "react"
import paths from "./paths"

export function IconDefs() {
  return (
    <svg style={{ display: "none" }}>
      <defs>
        {Object.values(paths).map(icon => (
          <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            key={icon.id}
            id={icon.id}
          >
            <path d={icon.path} />
          </svg>
        ))}
      </defs>
    </svg>
  )
}
